export default __webpack_public_path__ + "static/media/TitleText.c20ff1fc.svg";